<div class="modal-container">
    <div class="modal-header justify-content-start">
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
            <img class="back-button" [src]="translate.currentLang == 'ar'? 'assets/svg/arrow_forward.svg' : 'assets/svg/arrow_back.svg'" width="24">
        </button>
        <h3 class="headline my-0 mx-3" fxFlex="auto">{{'product_variants'|translate}}</h3>
    </div>
    <div class="modal-body">
        <app-variant-product-items [currentProductId]="currentProductId" [productVariants]="productVariants"></app-variant-product-items>
    </div>
</div>